import { TeacherModel } from "redux/models/home";
import { axiosClient } from "./client";
import {
  GET_FAVORITE_EXPERTS,
  GET_EXPERT_BY_ID,
  GET_ALL_EXPERTS,
  GET_TEACHER_BY_ID,
  GET_BOOKMARKED_EXPERTS
} from "./client/endpoints";

const fetchFavoriteExpertsList = async (): Promise<any> => {
  try {
    const res = await axiosClient.get<any>(GET_FAVORITE_EXPERTS);
    return res.data;
  } catch (e) {
    return [];
  }
};

const addFavouriteExpert = async (data: any): Promise<any> => {
  const res = await axiosClient.post<any>(GET_FAVORITE_EXPERTS, data);
  return res.data;
};

const getBookmarkedExpert = async (): Promise<any> => {
  const res = await axiosClient.get<any>(GET_BOOKMARKED_EXPERTS);
  return res.data?.data?.[0];
};

const getExpertById = async (data: any): Promise<any> => {
  try {
    const response = await axiosClient.post<any>(GET_EXPERT_BY_ID, data);
    return response.data;
  } catch (e) {
    return [];
  }
};
const getTeacherById = async (id: number): Promise<TeacherModel> => {
  const response = await axiosClient.get<{ data: { data: TeacherModel } }>(
    `${GET_TEACHER_BY_ID}/${id}`
  );
  return response.data?.data?.data;
};
// * get all experts
const getAllExperts = async (data: any): Promise<any> => {
  try {
    const response = await axiosClient.get<any>(`${GET_ALL_EXPERTS}?language=${data.language}&country=${data.country}&keyword=${data.keyword}`);
    return Array.isArray(response.data?.data) && response.data?.data.length > 0  ? response.data?.data?.[0].map((expert: any) => {
      return { ...expert, expert_country: expert.country };
    }) : [];
  } catch (e) {
    return [];
  }
};

const ExpertsService = {
  fetchFavoriteExpertsList,
  addFavouriteExpert,
  getExpertById,
  getAllExperts,
  getTeacherById,
  getBookmarkedExpert
};

export default ExpertsService;
